import Vue from 'vue';
import * as C from '../constants';
import defaultState from '../affiliate/defaultState';

export default {
  [C.AFFILIATES_RESET](state) {
    Object.assign(state, defaultState());
  },

  [C.AFFILIATES_DOMAINS_PENDING](state) {
    state.domains = {
      loading: true,
      error: false,
      items: [],
    };
  },

  [C.AFFILIATES_DOMAINS_SUCCESS](state, payload) {
    state.domains = {
      loading: false,
      items: payload,
    };
  },

  [C.AFFILIATES_DOMAINS_FAILURE](state) {
    state.domains = {
      loading: false,
      error: true,
    };
  },

  [C.AFFILIATES_PENDING](state) {
    state.affiliates = {
      loading: true,
      error: false,
      noContent: false,
      items: [],
    };
  },

  [C.AFFILIATES_SUCCESS](state, payload) {
    state.affiliates = {
      ...state.affiliates,
      loading: false,
      items: payload,
    };
  },

  [C.AFFILIATES_FAILURE](state) {
    state.affiliates = {
      ...state.affiliates,
      loading: false,
      error: true,
    };
  },

  [C.AFFILIATES_NO_CONTENT](state) {
    state.affiliates = {
      ...state.affiliates,
      loading: false,
      noContent: true,
    };
  },

  [C.AFFILIATES_AFFILIATE_PENDING](state) {
    state.affiliate = {
      ...state.affiliate,
      loading: true,
      error: false,
      item: undefined,
    };
    state.affiliateSuppliers.items = [];
  },

  [C.AFFILIATES_AFFILIATE_SUCCESS](state, payload) {
    state.affiliate = {
      ...state.affiliate,
      loading: false,
      item: payload,
    };
  },

  [C.AFFILIATES_AFFILIATE_FAILURE](state) {
    state.affiliate = {
      ...state.affiliate,
      loading: false,
      error: true,
    };
  },

  [C.AFFILIATES_AFFILIATE_UPDATE_PENDING](state) {
    state.affiliate.loading = true;
    state.affiliate.error = false;
  },

  [C.AFFILIATES_AFFILIATE_UPDATE_SUCCESS](state, payload) {
    state.affiliate = {
      ...state.affiliate,
      loading: false,
      item: payload.newAffiliate,
    };
    Vue.set(
      state.affiliates.items,
      payload.affiliateIndex,
      {
        ...state.affiliates.items[payload.affiliateIndex],
        name: payload.newAffiliate.name,
      },
    );
  },

  [C.AFFILIATES_AFFILIATE_UPDATE_FAILURE](state) {
    state.affiliate.loading = false;
    state.affiliate.error = true;
  },

  [C.AFFILIATES_AFFILIATE_LOGO_PENDING](state) {
    state.logo = {
      loading: true,
      error: false,
    };
  },

  [C.AFFILIATES_AFFILIATE_LOGO_SUCCESS](state, payload) {
    state.logo = {
      loading: false,
    };
    Vue.set(
      state.affiliate.item.domains,
      payload.affiliateDomainIndex,
      {
        ...state.affiliate.item.domains[payload.affiliateDomainIndex],
        logo: payload.logo,
      },
    );
  },

  [C.AFFILIATES_AFFILIATE_LOGO_FAILURE](state) {
    state.logo = {
      loading: false,
      error: true,
    };
  },

  [C.AFFILIATES_AFFILIATE_SUPPLIERS_SET](state, payload) {
    state.affiliateSuppliers.items = payload;
  },

  [C.AFFILIATES_AFFILIATE_SUPPLIERS_ADD](state, payload) {
    state.affiliateSuppliers.items.push(payload);
  },

  [C.AFFILIATES_AFFILIATE_SUPPLIERS_REMOVE](state, payload) {
    state.affiliateSuppliers.items.splice(payload, 1);
  },

  [C.AFFILIATES_AFFILIATE_SUPPLIERS_SYNC_PENDING](state) {
    state.affiliateSuppliers = {
      ...state.affiliateSuppliers,
      loading: true,
      error: false,
    };
  },

  [C.AFFILIATES_AFFILIATE_SUPPLIERS_SYNC_SUCCESS](state, payload) {
    if (payload) {
      Vue.set(state.affiliateSuppliers.items, payload.affiliateSupplierIndex, {
        ...state.affiliateSuppliers.items[payload.affiliateSupplierIndex],
        domains: payload.domains,
      });
    }
    state.affiliateSuppliers = {
      ...state.affiliateSuppliers,
      loading: false,
      error: false,
    };
  },

  [C.AFFILIATES_AFFILIATE_SUPPLIERS_SYNC_FAILURE](state) {
    state.affiliateSuppliers = {
      ...state.affiliateSuppliers,
      loading: false,
      error: true,
    };
  },

  [C.AFFILIATES_AFFILIATE_SUPPLIERS_PENDING](state) {
    state.suppliers = {
      items: [],
      loading: true,
      error: false,
    };
  },

  [C.AFFILIATES_AFFILIATE_SUPPLIERS_SUCCESS](state, payload) {
    state.suppliers = {
      items: payload,
      loading: false,
    };
  },

  [C.AFFILIATES_AFFILIATE_SUPPLIERS_FAILURE](state) {
    state.suppliers = {
      loading: false,
      error: true,
    };
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/affiliate/mutations.js